import React from 'react';

const Features: React.FC = () => {
  return (
    <div className="page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-title">Our Features</h1>
          <p className="page-subtitle">
            Discover how TRAVEZE transforms your travel planning experience with cutting-edge AI technology
          </p>
        </div>
      </div>
      
      <section className="features-detailed">
        <div className="container">
          <div className="features-grid">
            <div className="feature-detail-card">
              <div className="feature-icon ai-icon"></div>
              <h3>AI-Powered Travel Planning</h3>
              <p>Our advanced AI algorithms analyze millions of travel data points to create personalized itineraries tailored to your preferences, budget, and travel style.</p>
              <ul className="feature-benefits">
                <li>Smart destination matching based on your interests</li>
                <li>Real-time price optimization</li>
                <li>Weather-aware scheduling</li>
                <li>Cultural preference learning</li>
              </ul>
            </div>
            
            <div className="feature-detail-card">
              <div className="feature-icon global-icon"></div>
              <h3>Global Coverage</h3>
              <p>Access detailed information for over 200 countries and 1000+ cities worldwide, with local insights from our network of travel experts.</p>
              <ul className="feature-benefits">
                <li>Local expert recommendations</li>
                <li>Hidden gem discoveries</li>
                <li>Cultural etiquette guides</li>
                <li>Language assistance tools</li>
              </ul>
            </div>
            
            <div className="feature-detail-card">
              <div className="feature-icon custom-icon"></div>
              <h3>Custom Itineraries</h3>
              <p>Every trip is unique. Our system creates fully customizable itineraries that adapt to your schedule, interests, and travel pace.</p>
              <ul className="feature-benefits">
                <li>Flexible day-by-day planning</li>
                <li>Activity time optimization</li>
                <li>Budget-conscious suggestions</li>
                <li>Group travel coordination</li>
              </ul>
            </div>
            
            <div className="feature-detail-card">
              <div className="feature-icon safety-icon"></div>
              <h3>Safety & Security</h3>
              <p>Travel with confidence knowing we provide real-time safety updates, emergency assistance, and secure booking processes.</p>
              <ul className="feature-benefits">
                <li>Real-time safety alerts</li>
                <li>Emergency contact integration</li>
                <li>Secure payment processing</li>
                <li>Travel insurance recommendations</li>
              </ul>
            </div>
            
            <div className="feature-detail-card">
              <div className="feature-icon support-icon"></div>
              <h3>24/7 Support</h3>
              <p>Our dedicated travel support team is available around the clock to assist you before, during, and after your journey.</p>
              <ul className="feature-benefits">
                <li>Round-the-clock assistance</li>
                <li>Multi-language support</li>
                <li>Instant chat support</li>
                <li>Emergency travel help</li>
              </ul>
            </div>
            
            <div className="feature-detail-card">
              <div className="feature-icon mobile-icon"></div>
              <h3>Mobile App</h3>
              <p>Take your travel plans anywhere with our intuitive mobile app featuring offline maps, real-time updates, and seamless synchronization.</p>
              <ul className="feature-benefits">
                <li>Offline map access</li>
                <li>Real-time itinerary updates</li>
                <li>Photo journal integration</li>
                <li>Expense tracking</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Features; 